<template>

 <div class="lamp" :class="{ online: isOnline && 'online' }"></div>
 
</template>


<script>
export default {
    name: 'Online',
    props: {
        isOnline:{
            type:Boolean
        }
    }
};
</script>

<style lang="scss" scoped>

.lamp {
  align-content: center;;
  height: 20px;
  width: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  &.online{
    background-color: green;
  }
  &.paper {
    border-radius: 0;
    background-color: #ddd;

    &.error {
        background-color: red;
    }
    &.low {
        background-color: #eac800;
    }
    &.ok {
        background-color: green;
    }
  }
}

</style>
